import { useEffect } from "react"
import { cn } from "shared/src/components/shadcn/lib/utils"

interface CopiedFlashProps extends React.HTMLAttributes<HTMLSpanElement> {
	show: boolean
	setShow: (show: boolean) => void
}

export const CopiedFlash = ({ show, setShow, className, ...props }: CopiedFlashProps) => {
	useEffect(() => {
		if (show) {
			setTimeout(() => {
				setShow(false)
			}, 1000)
		}
	}, [show, setShow])

	return (
		<span
			{...props}
			className={cn(
				"inline-block text-xs text-muted-foreground transition-opacity duration-200",
				show ? "visible animate-[flash-copied_0.8s_ease-in-out]" : "invisible opacity-0",
				className
			)}
			style={{
				animationFillMode: "forwards",
			}}>
			Copied!
		</span>
	)
}
